<template>

	<Outer>
		<SceneryVideoList type="COURSE"/>
	</Outer>


</template>
<script>

	import {MessageBox, Notification} from 'element-ui'
	import SceneryVideoList from "./List.vue";
	import Scenery from "../../../../common/model/lover/Scenery";
	import Outer from "../../article/Outer";

	export default {

		data () {
			return {}
		},
		props: {},
		components: {
			SceneryVideoList,
			Outer
		},
		computed: {},
		watch: {
			'$route' (to, from) {
				if (to.path !== from.path) {
					this.refresh();
				}
			}
		},
		methods: {
			refresh(){

			}
		},
		mounted(){
			this.refresh();
		}
	}

</script>



// WEBPACK FOOTER //
// SceneryCourseVideoList.vue?6e9fee19